import type {ReactElement} from 'react'
import {ButtonIcons} from '@/components/button-icons/button-icon'
import {EllipseButton} from '../flexible-web-toolkit/components/button/ellipse-button'

interface MarkerDetailedCardProps {
	address?: string
	directions: {
		lat?: number
		lng?: number
		searchLocation?: {lat: number; lng: number} | null
		text: string
	}
	name?: string
	phone?: string
	websiteUrl?: string
}

export const MarkerDetailedCard = ({
	address = '',
	directions,
	name = '',
	phone,
	websiteUrl,
}: MarkerDetailedCardProps): ReactElement => {
	const {lat, lng, searchLocation, text} = directions

	return (
		<div className="mx-2 my-4 max-w-xs">
			{name ? <p className="text-sm font-bold">{name}</p> : null}
			{address
				? address.split('\n').map((line) => (
						<p className="text-sm" key={line}>
							{line}
						</p>
					))
				: null}
			{phone ? (
				<div className="mt-5 flex">
					<EllipseButton
						className="flex-none"
						href={`tel:${phone}`}
						icon={ButtonIcons.Contact}
						noIconAnimation
						size="sm"
					/>
					<a
						className="ml-2 self-center truncate text-sm hover:underline"
						href={`tel:${phone}`}
					>
						{phone}
					</a>
				</div>
			) : null}
			{websiteUrl ? (
				<div className="mt-5 flex">
					<EllipseButton
						className="flex-none"
						href={
							websiteUrl.startsWith('http')
								? websiteUrl
								: `https://${websiteUrl}`
						}
						icon={ButtonIcons.Globe}
						noIconAnimation
						size="sm"
						target="_blank"
					/>
					<a
						className="ml-2 self-center truncate text-sm hover:underline"
						href={
							websiteUrl.startsWith('http')
								? websiteUrl
								: `https://${websiteUrl}`
						}
						rel="noreferrer"
						target="_blank"
					>
						{websiteUrl}
					</a>
				</div>
			) : null}
			{text ? (
				<a
					className="text-btn get-directions mt-5 block cursor-pointer whitespace-nowrap text-sm font-bold not-italic text-black underline hover:no-underline focus:text-secondary focus:no-underline focus:outline-none"
					href={
						searchLocation
							? `https://www.google.com/maps/dir/?api=1&origin=${searchLocation.lat},${searchLocation.lng}&destination=${lat},${lng}`
							: `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
					}
					rel="noreferrer"
					target="_blank"
				>
					{text}
				</a>
			) : null}
		</div>
	)
}
